module.exports = (rate) => {
    return rate+'%';
}


// WEBPACK FOOTER //
// ./src/filters/toFixedPercent.js